var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "receivers-list" }, [
    _c("div", { staticClass: "text-input" }, [
      _c("label", { staticClass: "required-flag" }, [
        _vm._v(_vm._s(_vm.$t("to"))),
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          { name: "hkldinput", rawName: "v-hkldinput" },
          { name: "autosize", rawName: "v-autosize" },
          {
            name: "fusioninputcheck",
            rawName: "v-fusioninputcheck",
            value: {
              type: "string",
              tip: _vm.invalidEmailTip,
              pattern: _vm.validateEmails,
              classes: "tooltip-class",
              required: true,
            },
            expression:
              "{\n        type: 'string',\n        tip: invalidEmailTip,\n        pattern: validateEmails,\n        classes: 'tooltip-class',\n        required: true\n      }",
          },
        ],
        staticClass: "autosize",
        attrs: { required: true },
        domProps: { value: _vm.displayTo },
        on: {
          input: function (event) {
            return _vm.updateEmails(event, "to")
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "text-input" }, [
      _c("label", [_vm._v(_vm._s(_vm.$t("cc")))]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          { name: "hkldinput", rawName: "v-hkldinput" },
          { name: "autosize", rawName: "v-autosize" },
          {
            name: "fusioninputcheck",
            rawName: "v-fusioninputcheck",
            value: {
              type: "string",
              tip: _vm.invalidEmailTip,
              pattern: _vm.validateEmails,
              classes: "tooltip-class",
              required: _vm.cc.trim(),
            },
            expression:
              "{\n        type: 'string',\n        tip: invalidEmailTip,\n        pattern: validateEmails,\n        classes: 'tooltip-class',\n        required: cc.trim()\n      }",
          },
        ],
        staticClass: "autosize",
        attrs: { required: _vm.cc.trim() },
        domProps: { value: _vm.displayCC },
        on: {
          input: function (event) {
            return _vm.updateEmails(event, "cc")
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "text-input" }, [
      _c("label", [_vm._v(_vm._s(_vm.$t("bcc")))]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          { name: "hkldinput", rawName: "v-hkldinput" },
          { name: "autosize", rawName: "v-autosize" },
          {
            name: "fusioninputcheck",
            rawName: "v-fusioninputcheck",
            value: {
              type: "string",
              tip: _vm.invalidEmailTip,
              pattern: _vm.validateEmails,
              classes: "tooltip-class",
              required: _vm.bcc.trim(),
            },
            expression:
              "{\n        type: 'string',\n        tip: invalidEmailTip,\n        pattern: validateEmails,\n        classes: 'tooltip-class',\n        required: bcc.trim()\n      }",
          },
        ],
        staticClass: "autosize",
        attrs: { required: _vm.bcc.trim() },
        domProps: { value: _vm.displayBCC },
        on: {
          input: function (event) {
            return _vm.updateEmails(event, "bcc")
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }